<template>
  <div id="goods">
    <template v-if="$store.state.userLevel">
      <div class="goods-header-bg">
        <img class="goods-img" :src="statisticData.img" alt="商品" />
        <div class="goods-name-source">
          <div class="goods-name twoLine">{{ statisticData.title }}</div>
          <div class="category">{{ statisticData.category }}</div>
          <div class="goods-price">
            直播最低价格：
            <span class="number-font">{{ statisticData.minPrice }}</span>
          </div>
          <div class="link">
            <router-link v-if="statisticData.shopLink" :to="statisticData.shopLink" class="shop oneLine">
              店铺：
              <img :src="statisticData.shopImg" alt="平台" class="platform-img" />
              {{ statisticData.shopName }}
            </router-link>&nbsp;&nbsp;
            <router-link v-if="statisticData.brandLink" :to="statisticData.brandLink" class="shop oneLine">
              品牌：
              <img :src="statisticData.brandImg" alt="平台" class="platform-img" />
              {{ statisticData.brandName }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="dateTab">
        <div class="dateTab__item" v-for="item of dateTabList" :key="item.name" :class="{ 'dateTab__item__active': item.value === dateTab }" @click="dateTab = item.value">{{ item.name }}</div>
      </div>
      <div class="staticBanner">
        <div class="staticBanner__item" >
          <div class="staticBanner__item__title">关联达人</div>
          <div class="staticBanner__item__value" >{{statisticData.anchorCount}}</div>
        </div>
        <div class="staticBanner__item" >
          <div class="staticBanner__item__title">关联直播</div>
          <div class="staticBanner__item__value" >{{statisticData.liveCount}}</div>
        </div>
        <div class="staticBanner__item" >
          <div class="staticBanner__item__title">销量</div>
          <div class="staticBanner__item__value" v-if="$store.state.userLevel <= 96">{{statisticData.salesVolume}}</div>
          <div class="staticBanner__item__value" v-else>****</div>
        </div>
        <div class="staticBanner__item" >
          <div class="staticBanner__item__title">销售额</div>
          <div class="staticBanner__item__value staticBanner__item__value__sales" v-if="$store.state.userLevel <= 96">{{statisticData.sales}}</div>
          <div class="staticBanner__item__value staticBanner__item__value__sales" v-else>****</div>
        </div>
      </div>
      <div class="contain" />
      <van-tabs v-model="active" color="#2A89F4" title-active-color="#2A89F4" line-width="1.875rem">
        <van-tab title="销售趋势">
          <SellIndextion  :params="params" :title="active"/>
        </van-tab>
        <van-tab title="关联达人">
          <GoodsAnchor :params="params" :title="active"/>
        </van-tab>
        <van-tab title="关联直播">
          <GoodsLive :params="params" :title="active"/>
        </van-tab>
      </van-tabs>
    </template>
    <LoginModule v-else />
  </div>
</template>

<script>
import SellIndextion from '@/modules/goods/SellIndextion';
import GoodsAnchor from '@/modules/goods/GoodsAnchor';
import GoodsLive from '@/modules/goods/GoodsLive.vue';
import routePushShare from '@/plugins/getShareCode';

export default {
  components: { SellIndextion, GoodsAnchor, GoodsLive },
  computed: {
    routeQuery() {
      return this.$route.query;
    },
    statisticData: ( _this = this ) => ({
      img:_this.statistic.imageUrl || _this.$defaultSrc, // 图片
      title: _this.statistic.title || '-', // 标题
      minPrice: _this.statistic?.minPrice ? '¥' + _this.$retainWan(_this.statistic?.minPrice) : '-', // 最低价格
      category: _this.statistic?.category?.name || '-', // 类目信息
      shopName: _this.statistic?.shop?.name || '-', //店铺名称
      shopLink: _this.statistic?.shop?.id ? `/shop/${_this.statistic?.shop?.id}` : '', // 店铺链接
      shopImg: _this.statistic?.shop?.logo ? _this.statistic?.shop?.logo :  _this.$defaultSrc, // 店铺图片
      brandName: _this.statistic?.brand?.name || '-', //品牌名称
      brandLink: _this.statistic?.brand?.id ? `/brand/${_this.statistic?.brand?.id}` : '', // 品牌链接
      brandImg: _this.statistic?.brand?.image? _this.statistic?.brand?.image :  _this.$defaultSrc, // 品牌图片
      anchorCount: _this.statistic?.anchorCount? _this.$retainWan(_this.statistic?.anchorCount) : '-', // 关联达人
      liveCount: _this.statistic?.anchorCount? _this.$retainWan(_this.statistic?.liveCount) : '-', // 关联达人
      salesVolume: _this.statistic?.anchorCount? _this.$retainWan(_this.statistic?.salesVolume) : '-', // 关联达人
      sales: _this.statistic?.anchorCount? '¥' + _this.$retainWan(_this.statistic?.sales) : '-', // 关联达人
    })
  },
  watch: {
    '$route':{
      deep:true,
      handler(){
        this.getStaticData()
      }
    },
    routeQuery(newValue) {
      this.active = Number(newValue.banner);
    },
    dateTab(value){
      this.params.timeMode = value
      this.getStaticData()
    }
  },
  data() {
    return {
      statistic:{},
      active: Number(this.$route.query.banner) || 0,
      dateTab:7,
      dateTabList:[{ name:'近7天',value:7 }, {name:'近30天',value:30}],
      staticApiData:{}, // 静态面板数据
      goods: {},
      params:{ timeMode:7,sort:'sales',order:'desc' }, // 各个列表使用
    };
  },
  mounted() {
    this.getStaticData()
  },
  methods: {
    /** 获取静态数据 **/
    async getStaticData(){
      const res = await this.$api.get(`v2/commodity/${this.$route.params.id}/statistic`,{params:this.params}).catch(_=>_)
      this.statistic = res.data || {}
    },
  }
};
</script>

<style lang="less" scoped>
#goods{
  background: #ffffff;
  padding-bottom: 1rem;
}
.goods-header-bg {
  height: 2.63rem;
  width: 100vw;
  background: linear-gradient(#2a89f4 0%, #54befa 100%);
  padding: 0.25rem 0.3rem 0;
  display: flex;
  align-items: flex-start;

  .category {
    display: inline-block;
    height: 0.3rem;
    line-height: 0.3rem;
    padding: 0 0.1rem;
    background: rgba(255, 255, 255, 0.19);
    font-size: 0.2rem;
    font-weight: 400;
    border-radius: 0.3rem;
    margin: 0.16rem 0.05rem 0;
  }

  .goods-img {
    width: 1.5rem;
    height: 1.5rem;
    object-fit: cover;
  }

  .goods-name-source {
    margin-left: 0.3rem;
    color: #fff;
    width: 5.1rem;

    .goods-name {
      font-size: 0.36rem;
      color: #fff;
    }

    .goods-price {
      margin: 0.18rem 0 0.2rem;
      font-size: 0.24rem;

      .number-font {
        font-size: 0.32rem;
      }
    }

    .link {
      display: flex;
      font-size: 0.24rem;

      .platform-img {
        width: 0.24rem;
        height: 0.24rem;
        vertical-align: top;
      }

      .shop {
        color: #ffffff;
        width: 50%;
      }
    }
  }

  .monitor {
    width: 1.6rem;
    height: 0.6rem;
    border: 0.01rem solid #ff9900;
    color: #ff9900;
    font-size: 0.28rem;
    text-align: center;
    line-height: 0.58rem;
    border-radius: 0.6rem;
    background: #fff;
  }
}
.dateTab{
  width: 100%;
  height: 0.88rem;
  border: 0.02rem solid #EDEDEE;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 0.24rem;
  &__item{
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A1A4A9;
    line-height: 0.24rem;
    padding: 0.1rem 0.16rem;
    margin-right: 0.02rem;
    &__active{
      color: #FFFFFF;
      background: #2877FF;
      border-radius: 0.08rem;
    }
  }
}
// 静态数据面板
.contain{
  width: 100%;
  height:0.16rem;
  background: #FBFAFA;
}
.staticBanner{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 1.28rem;
  &__item{
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.28rem;
    line-height: 0.28rem;
    &__title{
      color: #A1A4A9;
    }
    &__value{
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin-top: 0.16rem;
      &__sales{
        color: #FF5500 ;
      }
    }
  }
}
</style>
